import { useMutation } from "@tanstack/react-query";
import {
  client,
  type JobTaskCompleteSchema,
} from "@augmodo/lebron-browser-client";

export function useCompleteJobTask(jobId: string, taskId: string) {
  return useMutation({
    mutationFn: async (
      payload: JobTaskCompleteSchema,
    ): Promise<JobTaskCompleteSchema> => {
      const response = await client.patch({
        url: `/v1/jobs/${jobId}/tasks/${taskId}/complete`,
        body: payload,
      });

      if (response.error) {
        throw new Error(`Failed to complete job task: ${response.error}`);
      }

      return response.data as JobTaskCompleteSchema;
    },
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {
      console.error("Complete job task failed:", error);
    },
  });
}
